import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-ajuste-contrato',
  styleUrls: ['./btn-nuevo-tipo-ajuste-contrato.component.css'],
  templateUrl: './btn-nuevo-tipo-ajuste-contrato.component.html'
})
export class BtnNuevoTipoAjusteContratoComponent { }
